import { getAuth } from "firebase/auth";

// The current Firebase ID token, asked for at the moment a request is sent.
// Firebase answers from memory while the token is valid and renews it when
// it has expired or is within 30 seconds of expiring (ID tokens last one
// hour), so this costs a network call about once an hour per tab.
//
// Why: requests used to send the token copied into auth.data.jwt at page
// load. Nothing renewed that copy in an idle tab - the SDK only renews by
// itself when another Firebase product such as Firestore is running, and
// this app loads none - so the first click after an hour failed with an
// expired token. A 10-minute idle reload in SidebarContent.js hid that; it
// was removed on 2026-10-02 once this helper was live.
//
// `fallback` is the stored token, used only if Firebase cannot answer (no
// signed-in user yet, or the renewal request failed), which is what every
// caller sent before.
export const getFreshToken = async (fallback) => {
  try {
    const user = getAuth().currentUser;
    if (user) return await user.getIdToken();
  } catch (error) {
    console.log("could not get a fresh token", error);
  }
  return fallback ?? null;
};
